import {useStats} from './useStats';

export function useDailyStats(token) {
    return useStats(token, 'DAILY');
}
